/** Base pública dos arquivos servidos pelo Oikos (mesmo padrão de FaturamentoDashboard). */
export const OIKOS_FILES_BASE = 'https://oikos.ecoss.is/oikos/'

/** XML da NF — anexo vinculado à entidade `nf` (FaturamentoDashboard). */
export const TP_DOC_NF_XML = 39

/** PDF DANFE — anexo vinculado à entidade `nf` (FaturamentoDashboard). */
export const TP_DOC_NF_DANFE = 40

/**
 * PDF de liberação para faturamento — vinculado ao `rec` via documentoVinc (tabRef `rec`, tabId rec_id).
 * Deve existir em `tpDocumento` com o mesmo id; ajuste se o cadastro no BD for outro.
 */
export const TP_DOC_REC_LIBERACAO_FATURAMENTO = 41

/** Pedido de emissão NFS-e na Kamino (PHP Oikos). */
export const KAMINO_EMIT_NFSE_URL = `${OIKOS_FILES_BASE}_kamino_emitNFSE.php`

/** Sync de NFS-e emitidas na Kamino → nf/xml/pdf no Oikos. */
export const KAMINO_CHECK_NFSE_URL = `${OIKOS_FILES_BASE}_kamino_checkNFSE.php`

/** Quem pode editar dados da NF e enviar pedido de emissão. */
export const KAMINO_EMIT_PF_IDS = [1, 2, 3, 31]
